<template>
  <div style="width: 100%">
    <v-autocomplete
      class="tema-eixo-combo"
      id="temas-select"
      v-model="filter.tipo"
      item-text="tipo"
      filled
      item-name="tipo"
      item-value="id"
      :items="tipoInscricao"
      label="Tipo"
      placeholder="Selecione um tipo"
      v-on:change="$emit('onChange')"
      :disabled="disabled"
      :clearable="clearable"
      :rules="rules"
      hide-details
      :multiple="multiple"
    >
      <template slot="no-data"> Nenhum tipo retornado </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "ComboTipoInscricao",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },

    filter: {
      type: Object,
      default: () => {
        ({ municipioId: null });
      },
    },

    label: {
      type: String,
      default: "",
    },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      tipoInscricao: [
        { tipo: "Parceiro", id: 2 },
        { tipo: "Sala do Empreendedor", id: 1 },
      ],
    };
  },
};
</script>

<style scoped>
/* .tema-eixo-combo {
  padding: 0 0 20px;
} */
</style>
